import { useQuery, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { ONE_HOUR } from '@constants';
import { FullScheduleData, FullScheduleResult } from '@common/types/api';
import { isValidObject } from '@utils';

import { fetchSchedule } from '../useLobbyQueries/queries';

type ScheduleFilters = {
  date?: string;
  roomId?: number;
};

export const useScheduleQuery = (page = 1, filters: ScheduleFilters) => {
  const queryClient = useQueryClient();
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'br';

  const sanitizedFilters = isValidObject(filters) ? filters : undefined;

  return useQuery<FullScheduleResult, AxiosError>(
    ['schedule', page, sanitizedFilters, currentLang],
    fetchSchedule,
    {
      staleTime: ONE_HOUR,
      onSuccess: ({ schedule }) => {
        schedule.map((session) =>
          queryClient.setQueryData<FullScheduleData>(
            ['session', session.id, currentLang],
            session,
          ),
        );
      },
    },
  );
};
